export const validation = {
  country_name: (value) => {
    if (!value?.trim()) return "Country name is required";
    return "";
  },
  country_code: (value) => {
    if (!value?.trim()) return "Country code is required";
    if (value.trim().length < 2)
      return "Country code must be at least 2 characters";
    return "";
  },
};
